<header *ngIf="isNotLtiEmbedded()" class="o-view-header page-header g-0">
  <div class="c-view-title">
    <h1 class="alpha" [ngSwitch]="isDraft">
      <ng-container
        *ngSwitchCase="true"
        i18n="@@sectionView-heading-sharedDraftFrom"
        >Shared draft section from {{ listTitle }}</ng-container
      >
      <ng-container *ngSwitchDefault i18n="@@sectionView-heading-sharedFrom"
        >Shared section from {{ listTitle }}</ng-container
      >
    </h1>
  </div>
</header>

<button
  *ngIf="showDeepLinkRelinkingButton()"
  i18n="@@sectionView-btn-embed-different-version"
  class="btn btn-primary btn-lg btn-responsive qa-section-view__embed_different_version_btn"
  (click)="navigateToDeepLinkRelinking()"
>
  Embed a different version
</button>

<rl-lti-alert [paramMap]="queryParamMap"></rl-lti-alert>

<rl-section-list-details
  [list]="list"
  [permissions]="permissions"
></rl-section-list-details>

<rl-section-alerts
  [list]="list"
  [permissions]="permissions"
  [rolledOverTo]="rolledOverTo"
></rl-section-alerts>

<rl-view-container
  [containerRoot]="containerRoot"
  [containerStructure]="containerStructure$ | async"
  [entryVisibility]="filteredEntryIds$ | async"
  [sectionsById]="sectionsById$ | async"
>
</rl-view-container>

<rl-report-broken-link-modal></rl-report-broken-link-modal>
<rl-share-sheet-modal></rl-share-sheet-modal>
<rl-report-broken-link-modal></rl-report-broken-link-modal>
